<template>
	<div class="pre-date">
		<label class="pre-inline">{{pre_item.name}}:</label>
		<el-date-picker v-model="pre_item.val" type="date" :class="[pre_item.class==''?'short0':pre_item.class]"
			value-format="yyyy-MM-dd" placeholder="选择日期" @change="val_back">
		</el-date-picker>
		<em class="pre-em"  v-show="pre_item.w=='1'">*</em><em class="pre-em"  v-show="pre_item.w=='0'"></em>
	</div>
</template>

<script>
	//
	export default {
		name: "hj-date",
		data() {
			return {
				pre_item: {},
			}
		},
		props: {
			inData: {
				type: String,
				default: ''
			}
		},
		watch: {
			inData(val) {
				this.pre_item = {};
				this.pre_item = JSON.parse(this.inData);
			}
		},
		created() {
			this.pre_item = {};
			this.pre_item = JSON.parse(this.inData);
			// console.log(this.pre_item);
		},
		activated: function() {
			// console.log('keep-alive 组件激活时调用 hj-input激活');
			// console.log(this.inData);
			this.pre_item = {};
			this.pre_item = JSON.parse(this.inData);
		},
		deactivated: function() {
			// console.log('hj-input 组件激活时调用 停用');
			this.pre_item = {};
		},
		methods: {
			val_back: function() {
				this.$emit('com-event', this.pre_item);
			}
		}
	}
</script>

<style scoped="scoped">
	.pre-date {
		display: flex;
		align-items: center;
	}

	.pre-inline {
		display: inline-block;
		vertical-align: middle;
		margin-right: 2px;
		min-width: 108px;
	}
	
	.pre-em {
		display: inline-block;
		vertical-align: middle;
		width: 10px;
	}
</style>
